// Menus desktop (déroulant et méga menu de Dawn) : ouverture au survol de la souris, en plus du clic.
// Écoute posée sur le document (survit au rechargement du header dans le customizer) et déclenchée par le type
// de pointeur « souris », pas par la largeur d'écran (l'aperçu du customizer est plus étroit que l'écran).
// Délai de fermeture court pour pouvoir descendre de l'onglet au panneau sans qu'il se referme.
(() => {
  const CLOSE_DELAY = 200;
  const timers = new WeakMap();

  const setOpen = (details, open) => {
    if (!details || details.open === open) return;
    details.open = open;
    details.querySelector('summary')?.setAttribute('aria-expanded', String(open));
  };

  const menuFrom = (node) => (node instanceof Element ? node.closest('header-menu') : null);

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const menu = menuFrom(event.target);
    if (!menu) return;
    clearTimeout(timers.get(menu));
    const details = menu.querySelector('details');
    document.querySelectorAll('header-menu details[open]').forEach((other) => {
      if (other !== details) setOpen(other, false);
    });
    if (!details.open) menu.dataset.dxHoverOpened = String(Date.now());
    setOpen(details, true);
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse') return;
    const menu = menuFrom(event.target);
    if (!menu || menu.contains(event.relatedTarget)) return;
    timers.set(
      menu,
      setTimeout(() => setOpen(menu.querySelector('details'), false), CLOSE_DELAY)
    );
  });

  // Ouvert par le survol : le clic qui suit sur l'onglet ne doit pas le refermer sous la souris.
  document.addEventListener('click', (event) => {
    const summary = event.target instanceof Element ? event.target.closest('header-menu summary') : null;
    if (!summary) return;
    const menu = summary.closest('header-menu');
    if (menu.dataset.dxHoverOpened && summary.parentElement.open) event.preventDefault();
  });
})();

// En-tête « toujours collant » (réglages du header > Sticky header > Always) : la barre d'annonce et toute
// section du groupe placée au-dessus de l'en-tête collent avec lui, empilées, comme sur le modèle Smooche.
(() => {
  const observed = new WeakSet();
  const stack = () => {
    const header = document.querySelector('.section-header');
    if (!header) return;
    const type = header.querySelector('sticky-header')?.dataset.stickyType;
    const sticky = type === 'always' || type === 'reduce-logo-size';
    const above = [];
    for (let el = header.previousElementSibling; el; el = el.previousElementSibling) {
      if (el.classList.contains('shopify-section-group-header-group')) above.unshift(el);
    }
    // Hauteurs exactes (offsetHeight arrondit : 54,59 px devenait 55 px et laissait un jour de 0,41 px).
    // Position arrondie vers le bas : chaque section glisse d'une fraction de pixel sous celle du dessus.
    let top = 0;
    above.forEach((el) => {
      el.classList.toggle('dx-sticky-above', sticky);
      el.style.top = sticky ? `${Math.floor(top)}px` : '';
      if (sticky) top += el.getBoundingClientRect().height;
    });
    header.style.top = sticky && top ? `${Math.floor(top)}px` : '';
    [header, ...above].forEach((el) => {
      if (observed.has(el)) return;
      observed.add(el);
      new ResizeObserver(stack).observe(el);
    });
  };
  stack();
  document.addEventListener('shopify:section:load', stack);
})();

// En-tête transparent sur le hero : suit la hauteur de l'en-tête (logo, largeur d'écran, rechargement de
// l'en-tête dans le customizer). Ignorée une fois défilé, quand le logo réduit ne doit pas faire bouger la page.
(() => {
  let observed;
  const watch = () => {
    const header = document.querySelector('.section-header');
    if (!header || header === observed || !document.querySelector('#MainContent > .shopify-section:first-child .dx-hero-section--under-header')) return;
    observed = header;
    new ResizeObserver(() => {
      if (header.classList.contains('scrolled-past-header')) return;
      document.documentElement.style.setProperty('--dx-header-h', `${header.offsetHeight}px`);
    }).observe(header);
  };
  watch();
  document.addEventListener('shopify:section:load', watch);
})();
